var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { formHookExtensions } from './FormHookExtensions';
import { FormikAdapter } from './FormikAdapter';
/** Do not use this unless you are creating a new type of useForm */
export function useFormBase(_a) {
    var formAdapter = _a.formAdapter, otherProps = __rest(_a, ["formAdapter"]);
    var _b = formAdapter(otherProps), actions = _b.actions, state = _b.state, context = _b.context;
    var hookWithoutExtensions = __assign(__assign(__assign({}, actions), state), { context: context });
    return __assign(__assign({}, hookWithoutExtensions), formHookExtensions(hookWithoutExtensions));
}
/**
 * Hook for handling a forms, validation and submission
 *
 * @example
 * ```tsx
 * interface Form {
 *     name: string;
 * }
 *
 * function ExampleComponent() {
 *      const form = useForm({
 *          defaultValues: { name: '' },
 *          validationSchema: yup.object().shape<Form>({ name: yup.string().required() }),
 *          onSubmit: async (values) => {
 *              await callSomeAsyncFunction(values);
 *          }
 *      });
 *
 *      return (
 *          <form onSubmit={form.submitForm} noValidate>
 *              <input type='text' value={form.values.name} onChange={e => form.setFieldValue('name' e.target.value)} />
 *              <input type='text' {...form.registerInput('name')} />
 *              {!form.isValid && <label>Form has errors</label>}
 *          </form>
 *      );
 * ```
 */
export function useForm(props) {
    return useFormBase(__assign(__assign({}, props), { formAdapter: FormikAdapter }));
}
